import React from "react";

import { useQuery } from "react-query";

import PropTypes from "prop-types";

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import Utilisateur from 'components/Shared/Utilisateur';

import { fetchUtilisateurAgence } from 'utils/queries';


const UtilisateurAgence = ({ onChange, codeAgence, utilisateurId, autoFocus }) => {


    const [value, setValue] = React.useState(utilisateurId > 0 ? utilisateurId : '');

    React.useEffect(() => {
        setValue(utilisateurId > 0 ? utilisateurId : '');
    }, [utilisateurId]);

    const {
        isLoading,
        error,
        data,
        //isFetching,
        //refetch,
    } = useQuery(
        {
            queryKey: ["UtilisateurAgence", { codeAgence }],
            queryFn: () => fetchUtilisateurAgence({ codeAgence }),
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        }
    );


    const handleChange = (e) => {
        var id = e.target.value;
        var utilisateur = data.find(u => u.id === id);
        setValue(id);
        onChange(utilisateur);
    };


    return (
        <>

            {error && (`Erreur de chargement de la liste des utilisateurs de l'agence ${codeAgence} - contacter le support.`)}

            {!isLoading && !error && (
                <TextField
                    select
                    label={`Confirmation du nom de l'émetteur :`}
                    value={value}
                    onChange={handleChange}
                    required={true}
                    error={false}
                    fullWidth
                    disabled={false}
                    variant="outlined"
                    InputLabelProps={{
                        shrink: true
                    }}
                    autoFocus={autoFocus}
                >

                    {data.map(utilisateur => (
                        <MenuItem key={utilisateur.id} value={utilisateur.id}>
                            <Utilisateur utilisateur={utilisateur} format="simple" />
                        </MenuItem>
                    ))}

                </TextField>
            )}


            
            </>
    );
}



UtilisateurAgence.propTypes = {
    onChange: PropTypes.func.isRequired,
    codeAgence: PropTypes.string.isRequired,
    autoFocus: PropTypes.bool,
};

UtilisateurAgence.defaultProps = {
    autoFocus: false
};

export default UtilisateurAgence;
